module.exports = __webpack_public_path__ + "static/media/winchester-9.1529b4ee.svg";